import React from 'react';

const DC = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="m5.075688,23.839641l7.599996,-23.416203l7.599996,23.416203l-19.924313,-14.481073l24.648635,0" />
    </g>
  </svg>
);

export default DC;
